import Reflux from "reflux";
import Actions from "./DashboardActions";
import logger from "../../utils/LoggerFrontend";

export const ALL_STATUSES = [
  "DRAFT",
  "IN_PROGRESS",
  "WAITING_FOR_APPROVAL",
  "SCHEDULED",
  "ACTIVE",
  "PAUSED",
  "FINISHED",
  "REJECTED",
  "CANCELLED"
];

export const STATUSES_TO_LOAD_AT_BEGINNING = [
  "DRAFT",
  "IN_PROGRESS",
  "WAITING_FOR_APPROVAL",
  "SCHEDULED",
  "ACTIVE",
  "PAUSED",
  "REJECTED",
  "CANCELLED"
];

export const DEFAULT_STATUSES = [
  "DRAFT",
  "IN_PROGRESS",
  "WAITING_FOR_APPROVAL",
  "SCHEDULED",
  "ACTIVE",
  "PAUSED"
];

const defaultState = {
  filters: {
    statuses: DEFAULT_STATUSES,
    companies: [],
    owners: [],
    dates: []
  },
  finishedCampaignsHaveBeenLoaded: false,
  sortBy: undefined,
  sortOrder: undefined
};

export default class DashboardStore extends Reflux.Store {
  constructor(props) {
    super(props);

    this.state = Object.assign({}, defaultState);

    this.listenables = Actions;
  }

  onResetFilters() {
    logger.debug("DashboardStore:onResetFilters", "called... ");
    this.setState({ ...defaultState });
  }

  onHandleFilters({
    statuses: newStatuses,
    companies: newCompanies,
    owners: newOwners,
    dates: newDates
  }) {
    const statuses = newStatuses || this.state.filters.statuses;
    const companies = newCompanies || this.state.filters.companies;
    const owners = newOwners || this.state.filters.owners;
    const dates = newDates || this.state.filters.dates;

    let newState = { filters: { statuses, companies, owners, dates } };
    this.setState(newState);
  }

  onUpdateSortBy(sortBy) {
    this.setState({ sortBy });
  }

  onUpdateSortOrder(sortOrder) {
    this.setState({ sortOrder });
  }

  onSetFinishedCampaignsHaveBeenLoaded(finishedCampaignsHaveBeenLoaded) {
    this.setState({ finishedCampaignsHaveBeenLoaded });
  }
}
